import { ChangeRtlLtrSettingsPanel } from './ChangeRtlLtrSettingsPanel';
export { RtlLtrSettingsManagerEntryPoint } from './rtlLtrSettingsManagerEntry';

export const panels = {
  changeRtlLtrSettingsPanel: ChangeRtlLtrSettingsPanel,
};
